import { FieldWrapper, Label, Textarea } from '@commenda/kakashi';
import { useState } from 'react';

interface AgentCustomInstructionsFieldProps {
  customInstructions: string | undefined;
  onChange: (customInstructions: string | undefined) => void;
}

export const AgentCustomInstructionsField = ({
  customInstructions,
  onChange,
}: AgentCustomInstructionsFieldProps) => {
  const [draft, setDraft] = useState(customInstructions ?? '');

  return (
    <FieldWrapper>
      <Label optional>Extra instructions for this step</Label>
      <Textarea
        rows={4}
        value={draft}
        placeholder="Anything this particular step should be told, on top of the expert's own instructions..."
        onChange={(event) => {
          setDraft(event.target.value);
          onChange(event.target.value.trim() ? event.target.value : undefined);
        }}
      />
      <p className="txt-extra-small-regular mt-xs text-text-secondary">
        Added <strong>after</strong>&nbsp;the expert&apos;s own instructions,
        never instead of them, so this wording wins a genuine disagreement. To
        replace them outright, use the system prompt above.
      </p>
    </FieldWrapper>
  );
};
